import { withStyles, Typography } from '@material-ui/core';

const boldWeight = 'bold';
const normalWeight = 'normal';

export const HeadlineText = withStyles(() => ({
  root: {
    fontWeight: 900,
    fontSize: 22,
    lineHeight: '32px',
  },
}))(Typography);

export const HeaderText = withStyles(() => ({
  root: {
    fontWeight: boldWeight,
    fontSize: 16,
    lineHeight: '23px',
  },
}))(Typography);

// They share the same styles
export const InputText = HeaderText;

export const SubTitle1Text = withStyles(() => ({
  root: {
    fontWeight: 900,
    fontSize: 18,
    lineHeight: '26px',
  },
}))(Typography);

export const SubTitle2Text = withStyles(() => ({
  root: {
    fontWeight: 900,
    fontSize: 16,
    lineHeight: '23px',
  },
}))(Typography);

export const SubTitle3Text = withStyles(() => ({
  root: {
    fontWeight: 700,
    fontSize: 15,
    lineHeight: '17px',
  },
}))(Typography);

export const H4Text = withStyles(() => ({
  root: {
    fontWeight: normalWeight,
    fontSize: 14,
    lineHeight: '20px',
  },
}))(Typography);

// Share styles
export const Body1Text = H4Text;

export const Body2Text = withStyles(() => ({
  root: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '17px',
  },
}))(Typography);

export const ButtonText = withStyles(() => ({
  root: {
    fontWeight: normalWeight,
    fontSize: 16,
    lineHeight: '23px',
    textTransform: 'uppercase',
  },
}))(Typography);

export const CaptionText = withStyles(() => ({
  root: {
    fontWeight: 500,
    fontSize: 9,
    lineHeight: '13px',
  },
}))(Typography);

// They share the same style
export const OverlineText = CaptionText;
